export const sortSubscriptionList = (list) => {
  const sortedList = [...list];
  return sortedList.sort((a, b) => {
    if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) return -1;
    if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) return 1;
    return 0;
  });
};

export default sortSubscriptionList;
